// Phone.js

const PHONE_ALLOWED_FORMATTING_REGEX = /^[\d\s()+.-]*$/;

const getPhoneDigits = (value) => String(value ?? '').replace(/\D+/g, '');

const isPhoneMaskableInput = (value) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return true;
  return PHONE_ALLOWED_FORMATTING_REGEX.test(trimmed);
};

const formatUsPhoneFromDigits = (digits, { includeCountryCode = false } = {}) => {
  const normalizedDigits = String(digits ?? '').replace(/\D+/g, '');
  if (!normalizedDigits) return '';

  let localDigits = normalizedDigits;
  let countryPrefix = '';

  if (normalizedDigits.length > 10 && normalizedDigits.startsWith('1')) {
    localDigits = normalizedDigits.slice(1, 11);
    if (includeCountryCode) {
      countryPrefix = '+1 ';
    }
  } else {
    localDigits = normalizedDigits.slice(0, 10);
  }

  if (localDigits.length <= 3) {
    return `${countryPrefix}(${localDigits}`.trim();
  }

  if (localDigits.length <= 6) {
    return `${countryPrefix}(${localDigits.slice(0, 3)}) ${localDigits.slice(3)}`.trim();
  }

  return `${countryPrefix}(${localDigits.slice(0, 3)}) ${localDigits.slice(3, 6)}-${localDigits.slice(6, 10)}`.trim();
};

const normalizePhoneValueForStorage = (value) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '';

  if (!isPhoneMaskableInput(trimmed)) {
    return trimmed;
  }

  const digits = getPhoneDigits(trimmed);

  if (digits.length === 10) {
    return `+1${digits}`;
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return `+${digits}`;
  }

  return trimmed;
};

const formatPhoneValueForInput = (value) => {
  const trimmed = String(value ?? '').trim();
  if (!trimmed) return '';

  if (!isPhoneMaskableInput(trimmed)) {
    return trimmed;
  }

  const digits = getPhoneDigits(trimmed);

  if (trimmed.startsWith('+1') && digits.length === 11 && digits.startsWith('1')) {
    return formatUsPhoneFromDigits(digits.slice(1));
  }

  if (digits.length <= 10) {
    return formatUsPhoneFromDigits(digits);
  }

  if (digits.length === 11 && digits.startsWith('1')) {
    return formatUsPhoneFromDigits(digits.slice(1));
  }

  return trimmed;
};

export {
  formatPhoneValueForInput,
  formatUsPhoneFromDigits,
  getPhoneDigits,
  isPhoneMaskableInput,
  normalizePhoneValueForStorage,
};